import { GetServerSideProps } from "next"
import { useTranslation, withTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Params } from "next/dist/shared/lib/router/utils/route-matcher"
import React, { Fragment } from "react"

const formatString = (value: string) => {
  const formattedString = value.replace(
    /<br>/g,
    '<br><span class="mb-4 block"></span>'
  )
  return formattedString
}

const PrivacyPolicy = () => {
  const { t } = useTranslation()
  const contentTerm = {
    title: t("term_of_service.title"),
    description: [
      t("term_of_service.desc_1"),
      t("term_of_service.desc_2"),
      t("term_of_service.desc_3"),
      t("term_of_service.desc_4"),
      t("term_of_service.desc_5")
    ],
    content: [
      {
        title: t("term_of_service.path_1_title"),
        description: [
          t("term_of_service.path_1_desc_1"),
          t("term_of_service.path_1_desc_2"),
          t("term_of_service.path_1_desc_3"),
          t("term_of_service.path_1_desc_4")
        ]
      },
      {
        title: t("term_of_service.path_2_title"),
        description: [
          t("term_of_service.path_2_desc_1"),
          t("term_of_service.path_2_desc_2"),
          t("term_of_service.path_2_desc_3")
        ]
      },
      {
        title: t("term_of_service.path_3_title"),
        description: [
          t("term_of_service.path_3_desc_1"),
          t("term_of_service.path_3_desc_2")
        ]
      },
      {
        title: t("term_of_service.path_4_title"),
        description: [t("term_of_service.path_4_desc_1")]
      },
      {
        title: t("term_of_service.path_5_title"),
        description: [
          t("term_of_service.path_5_desc_1"),
          t("term_of_service.path_5_desc_2")
        ]
      },
      {
        title: t("term_of_service.path_6_title"),
        description: [t("term_of_service.path_6_desc_1")]
      },
      {
        title: t("term_of_service.path_7_title"),
        description: [t("term_of_service.path_7_desc_1")]
      },
      {
        title: t("term_of_service.path_8_title"),
        description: [t("term_of_service.path_8_desc_1")]
      },
      {
        title: t("term_of_service.path_9_title"),
        description: [t("term_of_service.path_9_desc")]
      }
    ]
  }
  return (
    <div className="text-justify mt-8 px-[20px] term-service mb-[50px]">
      <p className="text-center Nunito-700 font-extrabold mb-2">
        {contentTerm.title}
      </p>
      {contentTerm.description.map((text: string, index: number) => {
        return (
          <p
            className="mb-2"
            key={index}
            dangerouslySetInnerHTML={{ __html: text }}
          ></p>
        )
      })}
      {contentTerm.content.map((item: any, index: number) => {
        return (
          <Fragment key={index}>
            <p className="Nunito-700 font-extrabold mb-2">{item.title}</p>
            {item.description.map((text: string, index: number) => {
              return (
                <p
                  className="mb-2"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: formatString(text) }}
                ></p>
              )
            })}
          </Fragment>
        )
      })}
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  locale
}: Params) => {
  return {
    props: {
      isShowSidebar: false,
      isShowTrending: false,
      isShowBottomBar: false,
      ...(await serverSideTranslations(locale, ["common"]))
    }
  }
}

export default withTranslation("common")(PrivacyPolicy)
